export const AI_SETTING_RESPONSE_MODE_TUTORIAL_URL = "https://tutorials.deeple.ai/getstarted/botsetting/response-mode";
